(function () {
  "use strict";

  // ---- SINGLE SOURCE OF TRUTH. Inches. Update here and nowhere else. ----
  var SIZES = [
    { name: "XXXS", us: "00", bust: 31.0, waist: 24.0, hip: 34.0 },
    { name: "XXS",  us: "0",  bust: 32.0, waist: 25.0, hip: 35.0 },
    { name: "XS",   us: "2",  bust: 33.0, waist: 26.0, hip: 36.0 },
    { name: "S",    us: "4",  bust: 34.0, waist: 27.0, hip: 37.0 },
    { name: "M",    us: "6",  bust: 35.0, waist: 28.0, hip: 38.0 },
    { name: "L",    us: "8",  bust: 36.0, waist: 29.0, hip: 39.0 },
    { name: "XL",   us: "10", bust: 37.0, waist: 30.0, hip: 40.0 },
    { name: "XXL",  us: "12", bust: 38.5, waist: 31.5, hip: 41.5 },
    { name: "XXXL", us: "14", bust: 40.5, waist: 33.5, hip: 43.5 }
  ];

  // Ghost values either side, so "one size out of range" is measurable.
  var EXT = {
    bust:  [30.0].concat(SIZES.map(function (s) { return s.bust; })).concat([42.5]),
    waist: [23.0].concat(SIZES.map(function (s) { return s.waist; })).concat([35.5]),
    hip:   [33.0].concat(SIZES.map(function (s) { return s.hip; })).concat([45.5])
  };

  var EMAIL = "hello@insolisia.com";

  function nearestIdx(v, arr) {
    var best = 0, bd = Infinity;
    for (var i = 0; i < arr.length; i++) {
      var d = Math.abs(v - arr[i]);
      if (d < bd - 1e-9) { bd = d; best = i; }
    }
    return best - 1; // -1 = below range, SIZES.length = above range
  }

  function card(chip, idx, why, primary) {
    return '<div class="fitting__rec' + (primary ? " is-primary" : "") + '">' +
      '<span class="fitting__chip">' + chip + "</span>" +
      '<span class="fitting__size">' + SIZES[idx].name + "</span>" +
      '<p class="fitting__why">' + why + "</p></div>";
  }

  function warn(title, body) {
    return '<div class="fitting__warn"><b>' + title + "</b><p>" + body + "</p></div>";
  }

  function recommend(b, w, h) {
    var W = nearestIdx(w, EXT.waist), B = nearestIdx(b, EXT.bust), H = nearestIdx(h, EXT.hip);

    if (W < 0 || W > SIZES.length - 1) {
      return warn("Your waist sits outside this edition.",
        "The Second Edition runs XXXS–XXXL. Rather than force a fit, write to " +
        '<a href="mailto:' + EMAIL + '">' + EMAIL + "</a> — we'd like to help, and future editions may run differently.");
    }

    var dB = B - W, dH = H - W, base = SIZES[W];

    // Hips two or three sizes BELOW the waist size do not constrain the fit --
    // the skirt simply falls with more room. Hips above, and bust either way, still do.
    var hipEasy = (dH <= -2 && dH >= -3);

    // Bust AND hips two or three sizes ABOVE the waist size: size to them, not to the waist.
    // They are what the dress cannot change; the interior band ties in at the waist.
    var bustHipUp = (dB >= 2 && dB <= 3 && dH >= 2 && dH <= 3);

    if (bustHipUp) {
      // FLAGGED TO RITA — deviation from the supplied code, one expression.
      // nearestIdx returns SIZES.length for a measurement above the top ghost
      // value, so B or H can be 9 while SIZES only runs 0-8. Unclamped,
      // SIZES[other].name threw and the panel rendered nothing — reproduced at
      // 39.75 / 29.75 / 44.75 in (101 / 75.6 / 113.7 cm) and 2,640 other
      // combinations. Clamped to the top size, matching how Update 03 already
      // clamps with Math.min(W + 1, SIZES.length - 1). The alternative reading
      // is to decline instead; say the word and it changes.
      var top = SIZES.length - 1;
      var fit = Math.min(B, H, top), other = Math.min(Math.max(B, H), top);
      var roomAt = (B > H) ? "bust" : "hip";
      var rr = card("your size", fit, "The bust and hip are what the dress can't change. The interior band ties in at the waist, so there is real adjustment there — " + SIZES[fit].name + " is the fit.", true);
      if (other !== fit) {
        rr += card("more room above", other, SIZES[other].name + " gives more ease at the " + roomAt + ", with more to draw in at the waist.", false);
      }
      return '<p class="fitting__verdict">Your bust and hips sit well above your waist size, so we size to them.</p>' +
        '<div class="fitting__recs' + (other !== fit ? " is-two" : "") + '">' + rr + "</div>";
    }

    // Bust two or three sizes above, hips at or below the waist size:
    // one size up -- room for the bodice without loosening the skirt.
    if (dB >= 2 && dB <= 3 && dH <= 1 && dH >= -3) {
      var up = Math.min(W + 1, SIZES.length - 1);
      var whyUp = (up === W + 1)
        ? SIZES[up].name + " gives the bodice the room it needs without loosening the skirt. The interior band ties in, so the waist still draws close — expect the bust to sit snug."
        : SIZES[up].name + " is the largest size in this edition. The waist will draw in with the band; expect the bust to sit snug.";
      return '<p class="fitting__verdict">Your bust runs well above your waist size.</p>' +
        '<div class="fitting__recs">' + card("your size", up, whyUp, true) + "</div>";
    }

    if (Math.abs(dB) >= 2 || dH >= 2 || dH < -3) {
      var far = [];
      if (Math.abs(dB) >= 2) far.push("bust");
      if (dH >= 2 || dH < -3) far.push("hips");
      return warn("We'd rather tell you than sell you.",
        "Your " + far.join(" and ") + " sit" + (far.length === 1 ? "s" : "") +
        " more than one size from your waist, and this cut is drafted around a closer relationship between the three. Write to " +
        '<a href="mailto:' + EMAIL + '">' + EMAIL + "</a> with your measurements and we'll give you an honest read.");
    }

    var verdict, recs;

    if (hipEasy) {
      if (dB === 0) {
        verdict = "Your bust and waist agree, and your hips sit well under them.";
        recs = card("your size", W, base.name + " is right for the waist and the bust — the two that hold a strapless dress up. The skirt will fall with more room through the hip.", true);
      } else if (dB === -1 && W > 0) {
        verdict = "Your bust sits a size below your waist, and your hips well below both.";
        recs = card("the defined waist", W - 1, "The corset at its strongest and the bodice closer at the bust. The skirt still falls easily through the hip.", true) +
               card("the easier wear", W, "Your waist exactly, with a little more room at the bust and plenty through the hip.", false);
      } else if (dB === 1 && W < SIZES.length - 1) {
        verdict = "Your bust sits a size above your waist, and your hips well below.";
        recs = card("the comfortable fit", W + 1, "Room where the bust asks for it, and the corset still draws a clear waist. The skirt falls loose at the hip either way.", true) +
               card("the strongest hold", W, "Maximum reduction at the waist, and closer at the bust. Only if you love a firm fit.", false);
      } else {
        verdict = "Your hips sit well under your waist size — the waist and bust decide.";
        recs = card("your size", W, base.name + " holds the waist and the bodice; the skirt will fall with more room through the hip.", true);
      }
    } else if (dB === 0 && dH === 0) {
      verdict = "All three agree — this is the fit the dress was drafted for.";
      recs = card("your size", W, "Bust, waist and hips all sit with " + base.name + ".", true);
    } else if (dB === -1 && dH === -1) {
      if (W === 0) {
        verdict = "Your bust and hips run lighter than your waist, and you're at the smallest size we make.";
        recs = card("your size", 0, "XXXS holds the waist firmly and sits a little easier above and below.", true);
      } else {
        verdict = "Your bust and hips sit a size below your waist, so you have a real choice.";
        recs = card("the defined waist", W - 1, "The corset works at its strongest — the full reduction, the most dramatic line. Snug by design.", true) +
               card("the easier wear", W, "Your waist exactly. Still a real reduction, with more ease through a long evening.", false);
      }
    } else if (dB === 1 && dH === 1) {
      if (W === SIZES.length - 1) {
        verdict = "Your bust and hips run a size above your waist, at the top of our range.";
        recs = card("your size", W, "XXXL holds the waist beautifully; expect a closer fit above and below.", true);
      } else {
        verdict = "Your bust and hips sit a size above your waist.";
        recs = card("the comfortable fit", W + 1, "Room where you need it, and the corset still draws a clear waist. This is the one we'd send you.", true) +
               card("the strongest hold", W, "Maximum reduction at the waist, but very close at bust and hip. Only if you love a firm fit.", false);
      }
    } else if ((dB === 0 && Math.abs(dH) === 1) || (dH === 0 && Math.abs(dB) === 1)) {
      var off = dB !== 0 ? "bust" : "hips";
      var d = dB !== 0 ? dB : dH;
      verdict = "Your " + off + " runs a size " + (d > 0 ? "above" : "below") + " your waist — the waist still decides.";
      recs = card("your size", W, base.name + " is right. The dress will sit " +
        (d > 0 ? "a touch closer" : "a touch easier") + " at the " + off + ", and exactly as drafted everywhere else.", true);
    } else {
      var closer = dB > 0 ? "bust" : "hips", easier = dB > 0 ? "hips" : "bust";
      verdict = "Your " + closer + " runs a size up and your " + easier + " a size down — the waist settles it.";
      recs = card("your size", W, base.name + ". The satin sits closer at the " + closer +
        " and easier at the " + easier + "; the corset sets the waist regardless.", true);
    }

    var two = recs.indexOf("fitting__rec") !== recs.lastIndexOf("fitting__rec");
    return '<p class="fitting__verdict">' + verdict + "</p>" +
      '<div class="fitting__recs' + (two ? " is-two" : "") + '">' + recs + "</div>";
  }

  function mount(root) {
    if (root.dataset.fittingReady === "true") return;   // never double-mount
    root.dataset.fittingReady = "true";

    var unit = "in";
    var title = root.dataset.fittingTitle || "Find your size";

    root.innerHTML =
      '<div class="fitting">' +
        '<div class="fitting__head"><h3>' + title + "</h3>" +
          '<div class="fitting__units">' +
            '<button type="button" class="is-on" data-u="in">in</button>' +
            '<button type="button" data-u="cm">cm</button></div></div>' +
        '<div class="fitting__fields">' +
          '<div class="fitting__field"><label>Bust<input class="f-bust" type="number" inputmode="decimal" step="0.1" placeholder="34"></label></div>' +
          '<div class="fitting__field"><label>Waist<input class="f-waist" type="number" inputmode="decimal" step="0.1" placeholder="27"></label></div>' +
          '<div class="fitting__field"><label>Hip<input class="f-hip" type="number" inputmode="decimal" step="0.1" placeholder="37"></label></div></div>' +
        '<button type="button" class="fitting__go">Find my size</button>' +
        '<div class="fitting__out" aria-live="polite"></div>' +
      "</div>";

    var out = root.querySelector(".fitting__out");

    root.querySelectorAll(".fitting__units button").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll(".fitting__units button").forEach(function (x) { x.classList.remove("is-on"); });
        b.classList.add("is-on");
        unit = b.getAttribute("data-u");
        var ph = unit === "in" ? ["34", "27", "37"] : ["86", "69", "94"];
        root.querySelector(".f-bust").placeholder = ph[0];
        root.querySelector(".f-waist").placeholder = ph[1];
        root.querySelector(".f-hip").placeholder = ph[2];
      });
    });

    root.querySelector(".fitting__go").addEventListener("click", function () {
      var b = parseFloat(root.querySelector(".f-bust").value);
      var w = parseFloat(root.querySelector(".f-waist").value);
      var h = parseFloat(root.querySelector(".f-hip").value);
      out.classList.add("is-shown");

      if (!(b > 0 && w > 0 && h > 0)) {
        out.innerHTML = warn("Three measurements, please.", "Bust, waist and hip decide together.");
        return;
      }
      if (unit === "cm") { b /= 2.54; w /= 2.54; h /= 2.54; }
      out.innerHTML = recommend(b, w, h);
    });
  }

  function renderChart(el) {
    var rows = SIZES.map(function (s) {
      return "<tr><td>" + s.name + "</td><td>" + s.us + "</td>" +
        "<td>" + s.bust.toFixed(1) + "</td><td>" + s.waist.toFixed(1) + "</td><td>" + s.hip.toFixed(1) + "</td>" +
        "<td>" + (s.bust * 2.54).toFixed(1) + "</td><td>" + (s.waist * 2.54).toFixed(1) + "</td><td>" + (s.hip * 2.54).toFixed(1) + "</td></tr>";
    }).join("");
    el.innerHTML =
      '<table class="fitting__chart"><thead>' +
      '<tr><th rowspan="2">Size</th><th rowspan="2">US</th><th colspan="3">in</th><th colspan="3">cm</th></tr>' +
      "<tr><th>Bust</th><th>Waist</th><th>Hip</th><th>Bust</th><th>Waist</th><th>Hip</th></tr>" +
      "</thead><tbody>" + rows + "</tbody></table>";
  }

  function init(scope) {
    (scope || document).querySelectorAll("[data-fitting]").forEach(mount);
    (scope || document).querySelectorAll("[data-fitting-chart]").forEach(renderChart);
    (scope || document).querySelectorAll("[data-fitting-toggle]").forEach(function (btn) {
      if (btn.dataset.fittingReady === "true") return;
      btn.dataset.fittingReady = "true";
      btn.addEventListener("click", function () {
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        if (!panel) return;
        var open = panel.hasAttribute("hidden");
        if (open) { panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden", ""); }
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.textContent = open ? "Close" : "Find your size";
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }
  // Theme editor re-renders a section: mount whatever appeared inside it.
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
